module.exports = __webpack_public_path__ + "static/media/illustration 5.840dc7af.png";